import { ThumbnailBaseCommonType } from '@systemeio/digital-store-shared'
import { DigitalProductErrorInterface } from '../../../digital-product/types/digital-product-interface'
import {
  PhysicalProductItemErrorsType,
  ProductDownloadItemErrorsType,
  ProductECourseItemErrorsType,
} from '../content/product/types/product-interface'
import { ThankYouPageErrorsType } from '../types/store-common-interface'

export const getThumbnailErrorChecker = (errors: Omit<ThumbnailBaseCommonType, 'thumbnail'>) =>
  !!errors.title || !!errors.subTitle || !!errors.buttonTitle

export const getBaseCheckoutErrorChecker = (
  errors:
    | ProductDownloadItemErrorsType
    | PhysicalProductItemErrorsType
    | ProductECourseItemErrorsType,
) =>
  !!errors['checkoutPage.coverId'] ||
  !!errors['checkoutPage.title'] ||
  !!errors['checkoutPage.buttonTitle'] ||
  !!errors['checkoutPage.description'] ||
  !!errors['checkoutPage.fields'] ||
  !!errors['digitalStore.paymentMethods']

export const getDigitalProductCheckoutErrorChecker = (
  errors: ProductDownloadItemErrorsType | ProductECourseItemErrorsType,
  digitalProductErrors: DigitalProductErrorInterface,
) =>
  getBaseCheckoutErrorChecker(errors) ||
  !!errors['digitalProduct.pricePlans'] ||
  !!digitalProductErrors.pricePlans?.length

export const getPhysicalProductCheckoutErrorChecker = (errors: PhysicalProductItemErrorsType) =>
  getBaseCheckoutErrorChecker(errors)

export const getThankYouErrorChecker = (errors: ThankYouPageErrorsType) =>
  !!errors['thankYouPage.title'] || !!errors['thankYouPage.text']

export const getOptionsErrorChecker = (digitalProductErrors: DigitalProductErrorInterface) =>
  !!digitalProductErrors.confirmationEmail?.subject ||
  !!digitalProductErrors.confirmationEmail?.body ||
  !!digitalProductErrors.confirmationEmail?.fromName ||
  !!digitalProductErrors.confirmationEmail?.fromEmail ||
  !!digitalProductErrors.confirmationEmail?.previewText
